import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
 
    {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
    },

    // {
    //     path: 'home',
    //     loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
    // },
    // {
    //     path: 'books',
    //     loadChildren: () => import('./book/book.module').then(m => m.BookModule)
    // },
    // {
    //     path: 'user',
    //     loadChildren: () => import('./user/user.module').then(m => m.UserModule)
    // },
    // {
    //     path: 'journals',
    //     loadChildren: () => import('./journal/journal.module').then(m => m.JournalModule)
    // },
    {
        path: 'content/:page_name_id',
        loadChildren: () => import('./journal/journal.module').then(m => m.JournalModule)
    },
    // {
    //     path: 'proceedings',
    //     loadChildren: () => import('./proceedings/proceedings.module').then(m => m.ProceedingsModule)
    // },
    // {
    //     path: 'contact',
    //     loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule)
    // },
    // {
    //     path: 'faq',
    //     loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
    // },
    {
        path: '**',
        loadChildren: () => import('./misc/misc.module').then(m => m.MiscModule)
    },
    // { path: '**', redirectTo: 'page-not-found/404', pathMatch: 'full' },


];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    anchorScrolling: 'enabled',
})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
